export const USERS_REQUEST = 'users/USERS_REQUEST';
export const USERS_SUCCESS = 'users/USERS_SUCCESS';
export const USERS_FAILURE = 'users/USERS_FAILURE';

export const USER_SAVE_REQUEST = 'users/USER_SAVE_REQUEST';
export const USER_SAVE_SUCCESS = 'users/USER_SAVE_SUCCESS';
export const USER_SAVE_FAILURE = 'users/USER_SAVE_FAILURE';

export const USER_UPDATE_REQUEST = 'users/USER_UPDATE_REQUEST';
export const USER_UPDATE_SUCCESS = 'users/USER_UPDATE_SUCCESS';
export const USER_UPDATE_FAILURE = 'users/USER_UPDATE_FAILURE';

export const CRM_USER_REQUEST = 'users/CRM_USER_REQUEST';
export const CRM_USER_SUCCESS = 'users/CRM_USER_SUCCESS';
export const CRM_USER_FAILURE = 'users/CRM_USER_FAILURE';

export const CRM_USER_UPDATE_REQUEST = 'users/CRM_USER_UPDATE_REQUEST';
export const CRM_USER_UPDATE_SUCCESS = 'users/CRM_USER_UPDATE_SUCCESS';
export const CRM_USER_UPDATE_FAILURE = 'users/CRM_USER_UPDATE_FAILURE';

export const CRM_DEPARTMENTS_REQUEST = 'users/CRM_DEPARTMENTS_REQUEST';
export const CRM_DEPARTMENTS_SUCCESS = 'users/CRM_DEPARTMENTS_SUCCESS';
export const CRM_DEPARTMENTS_FAILURE = 'users/CRM_DEPARTMENTS_FAILURE';
export const CRM_DEPARTMENTS_CLEAN = 'users/CRM_DEPARTMENTS_CLEAN';

export const USER_CLEAN = 'users/USER_CLEAN';

export const CRM_TEAMS_REQUEST = 'users/CRM_TEAMS_REQUEST';
export const CRM_TEAMS_SUCCESS = 'users/CRM_TEAMS_SUCCESS';
export const CRM_TEAMS_FAILURE = 'users/CRM_TEAMS_FAILURE';
export const CRM_TEAMS_CLEAN = 'users/CRM_TEAMS_CLEAN';
export const USER_UPDATE = 'users/USER_UPDATE';
